import { Check } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const problems = ["Integridad absoluta en cada transacción comercial", "Compromiso inquebrantable con la seguridad industrial", "Respeto profundo por el medio ambiente y comunidad", "Transparencia total en procesos de calidad y origen", "Innovación constante para la eficiencia del acero", "Responsabilidad social en toda nuestra cadena de valor", "Excelencia operativa basada en la honestidad técnica"];
export default function CodeOfEthics() {
  return <section data-section-id="260350" id="code-of-ethics" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary font-default mb-4">
            Nuestro Código de Ética
          </h2>
          <p className="text-muted-foreground font-default text-lg">
            Los principios fundamentales que guían cada una de nuestras operaciones en Kalisch Acero
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
          {problems.map((problem, i) => <Card key={i} data-index={i} className="py-0 shadow-md border border-border bg-card hover:border-primary/30 transition-colors duration-300 rounded-lg">
              <CardContent className="p-5 flex items-center gap-4">
                <div className="flex items-center justify-center size-8 rounded-md bg-primary/10 text-primary shrink-0">
                  <Check className="size-4" />
                </div>
                <p className="text-sm font-semibold text-foreground leading-snug font-default">
                  {problem}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}